import React from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { ArrowForward, AutoAwesome } from '@tmap/mmm-style-guide/src/Icon';

const CardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100%',
  borderRadius: '8px',
  backgroundColor: theme.palette.primary.veryLight,
  padding: theme.spacing(4),
  alignItems: 'center',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  '& .MuiButtonBase-root': {
    maxWidth: '100%',
    width: '210px',
  },
}));

const AutoAwesomeIcon = styled(AutoAwesome)(({ theme }) => ({
  color: theme.palette.blue.dark,
  marginBottom: theme.spacing(4.5),
  fontSize: '46px',
}));

function HowItWorksCard() {
  return (
    <CardContainer>
      <Grid
        container
        spacing={1}
        alignItems='center'
        direction='column'
      >
        <Grid item>
          <AutoAwesomeIcon />
        </Grid>
        <Grid item>
          <Typography color='blue.dark' variant='body2' align='center' fontSize='12px' letterSpacing='1px'>
            LEARN MORE
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant='h6' component='p' align='center' fontWeight={500}>
            Your place is calling, and we&apos;re here to help you get there – <Box component='span' fontWeight={600}>every step of the way.</Box>
          </Typography>
        </Grid>
        <Grid item sx={{ maxWidth: '100% !important' }}>
          <StyledButton
            disableElevation
            href='/how-it-works'
            variant='contained'
            color='primary'
            endIcon={<ArrowForward />}
          >
            How It Works
          </StyledButton>
        </Grid>
      </Grid>
    </CardContainer>
  );
}

export default HowItWorksCard;
